import React, { useMemo } from 'react';
import Divider from 'src/components/10-atoms/Divider';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import Column from 'src/components/10-atoms/layout/Column';
import ReadingColumn from 'src/components/10-atoms/layout/ReadingColumn';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import Tab from 'src/components/10-atoms/tabs/Tab';
import TabHeader from 'src/components/10-atoms/tabs/TabHeader';
import Tabs from 'src/components/10-atoms/tabs/Tabs';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { stripHTMLTags } from 'src/utils/html';
import { isWeb } from 'src/utils/platform';
import { pageAnalytics } from '../analytics';
import EFTimeline from '../containers/ExaminersFeedbackTimeline';
import AnswerItem from './AnswerItem';
import AnswerNotFound from './AnswerNotFound';
import Loader from './Loader';
import QuestionQueryHandler from './QuestionQueryHandler';
import QuestionReadingLoader from './QuestionReadingLoader';
/**
 * The shared reading body of a question: question text + answer / examiner's
 * feedback tabs. Rendered both by the full-page EP_Question route and by the
 * desktop master-detail reading pane. Reading width is capped via ReadingColumn.
 */
const QuestionReadingContent = ({ questionID, question, state, actions, }) => {
    const [{ theme }] = useTheme();
    const questionDetails = state.questionDetailsQuery.data?.ep_questionDetails ||
        (question?.data ? question : undefined);
    const questionString = useMemo(() => stripHTMLTags(questionDetails?.data?.questionHTML ?? ''), [questionDetails?.data?.questionHTML]);
    const handleRetry = () => actions.questionDetailsQuery.fetch();
    if (state.questionDetailsQuery.loading && !questionDetails) {
        return React.createElement(QuestionReadingLoader, null);
    }
    return (React.createElement(ReadingColumn, { flex: true },
        React.createElement(QuestionQueryHandler, { question: question, questionString: questionString, queryState: state.questionDetailsQuery, onRetry: handleRetry, onEditPress: actions.handleQuestionEditPress }),
        React.createElement(Divider, { mb: theme.spacing.standard.xs }),
        React.createElement(QueryHandler, { queryState: state.questionDetailsQuery, LoaderComponent: Loader, ErrorComponent: React.createElement(GenericServerError, { error: state.questionDetailsQuery.error, onRetry: handleRetry }), DataComponent: React.createElement(Column, null,
                state.tabs.tabs.length > 1 && (React.createElement(TabHeader, { role: "navigation", accessibilityLabel: "Question sections", ph: theme.spacing.page, activeIndex: state.tabs.activeIndex, tabs: state.tabs.tabs, onChange: (index) => {
                        pageAnalytics
                            .setWidget('TabHeader')
                            .setTarget(state.tabs.tabs[index].id)
                            .click();
                        actions.tabs.setActiveIndex(index);
                    } })),
                React.createElement(Tabs, { activeTab: state.tabs.tabs[state.tabs.activeIndex]?.id, behaviour: isWeb ? 'hide' : 'unmount' },
                    React.createElement(Tab, { id: "ANSWER" },
                        React.createElement(Column, { pt: theme.spacing.standard.sm }, questionDetails?.answer ? (React.createElement(AnswerItem, { answer: questionDetails.answer, contributors: state.answerContributors, questionID: questionID, updateAnswerLoading: state.updateAnswerMutation.loading, onEdit: actions.handleUpdateAnswer })) : (React.createElement(AnswerNotFound, { createAnswerLoading: state.createAnswerMutation.loading, onCreateAnswer: actions.handleCreateAnswer })))),
                    React.createElement(Tab, { id: "EXAMINERS_FEEDBACK" },
                        React.createElement(EFTimeline, { question: questionDetails })))) })));
};
export default QuestionReadingContent;
